import o from "./index.ce.vue2.js";
import r from "./index.ce.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ t(o, [["styles", [r]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/brand-category-selector/index.ce.vue.js
// module id = 1180
// module chunks = 41